<template>
  <div class="view-container">
    <form id="comingSoon" class="payment-result-form">
        <h1>Coming Soon</h1>
        <span>You can start Snap'n your tab soon.</span>
    </form>
  </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "ComingSoon",
  components: {
  }
};
</script>
